export default function React_ES6_Spread_Operator() {
  return (
    <div>
      <h1>React_ES6_Spread_Operator Component</h1>
      <p>This is the React_ES6_Spread_Operator tutorial page.</p>
    </div>
  );
}
